import getDynamicMenuPosition from '../../utils/getDynamicMenuPosition';
import React, { useState, useEffect, useRef } from 'react';
import { useEditorView } from '@remirror/react';
import { Dropdown, Tooltip } from 'antd';

const MENU_WIDTH = 300;
const MENU_HEIGHT = 320;

const ShortcutMenu = ({ items, onClickHandler, selectedOption, theme }) => {
  const menuRef = useRef(null);

  useEffect(() => {
    if (menuRef.current) {
      const menu = menuRef.current;
      const selectedItem = menu.querySelector(`[data-index="${selectedOption}"]`);
      if (selectedItem) {
        const menuRect = menu.getBoundingClientRect();
        const itemRect = selectedItem.getBoundingClientRect();
        if (itemRect.bottom >= menuRect.bottom) {
          menu.scrollTop += itemRect.bottom - menuRect.bottom + 20;
        } else if (itemRect.top <= menuRect.top) {
          menu.scrollTop -= menuRect.top - itemRect.top + 20;
        }
      }
    }
  }, [selectedOption]);

  return (
    <div ref={menuRef} className="emoji-shortcut-layout">
      <div className="emoji-shortcut-spacing">
        {items.map((item, index) => (
          <Tooltip key={item.code} title={item.name} placement="bottom" mouseEnterDelay={0.5}>
            <div
              className={`emoji-container${selectedOption === index ? ' selected' : ''}`}
              data-index={index}
              onClick={() => onClickHandler(item)}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = theme === 'dark' ? '#444' : '#f5f5f5';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor =
                  index === selectedOption ? (theme === 'dark' ? '#333' : '#eee') : 'transparent';
              }}
            >
              {item.emoji}
            </div>
          </Tooltip>
        ))}
      </div>
    </div>
  );
};

function EmojiShortcut({ items, open, selectedItem, range, onClickHandler }) {
  const [placementMemory, setPlacementMemory] = useState(null);
  const editorView = useEditorView();

  useEffect(() => {
    setPlacementMemory(null);
  }, [open]);
  if (!open) return null;

  const pos = getDynamicMenuPosition({
    coords: editorView.coordsAtPos(range?.from),
    maxWidth: MENU_WIDTH,
    maxHeight: MENU_HEIGHT,
    prevPlacement: placementMemory,
  });
  if (pos.placement !== placementMemory) {
    setPlacementMemory(pos.placement);
  }

  return (
    <Dropdown
      overlayClassName={`cms-shortcut emoji-shortcut-menu${items?.length === 0 ? ' collapse' : ''}`}
      open={open}
      trigger={[]}
      dropdownRender={() => (
        <ShortcutMenu items={items} selectedOption={selectedItem} onClickHandler={onClickHandler} />
      )}
      destroyPopupOnHide
      placement="bottomLeft"
      overlayStyle={{
        '--shortcut-width': MENU_WIDTH,
        '--shortcut-height': MENU_HEIGHT,
        position: 'fixed',
        top: pos.placement === 'top' ? pos?.top - 10 : pos?.top + 5,
        left: pos?.left ?? 100,
      }}
    >
      <span style={{ position: 'absolute', left: '0px', top: '0px', zIndex: 1, pointerEvents: 'none' }}>&nbsp;</span>
    </Dropdown>
  );
}

export default EmojiShortcut;
